import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { IagPortalDisruptedBookingsPage } from 'src/app/model/page/group/iag-portal/iag-portal-disrupted-bookings-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { GroupValidator } from 'src/app/validator/group-validator';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-iag-portal-disrupted-bookings-page',
  templateUrl: './iag-portal-disrupted-bookings-page.component.html',
  styleUrls: ['./iag-portal-disrupted-bookings-page.component.scss']
})
export class IagPortalDisruptedBookingsPageComponent implements OnInit {
  iagPortalDisruptedBookingsPage: IagPortalDisruptedBookingsPage = {} as IagPortalDisruptedBookingsPage;
  pageName = 'Disrupted bookings';
  iagPortalDisruptedBookings: any = [];
  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'iag-portal-disrupted-booking') {
        this.iagPortalDisruptedBookingsPage.htmlTitle = title.htmlTitle;
      }
    });
    this.iagPortalDisruptedBookingsPage.sections = [];
    this.iagPortalDisruptedBookingsPage.sectionsRefundConfirmationAccordion = [];
    this.iagPortalDisruptedBookingsPage.noteSections = [];
    this.iagPortalDisruptedBookingsPage.sectionsDisruptionViewAccordion = [];
    this.iagPortalDisruptedBookingsPage.sectionsRebookAccordion = [];
    const query = { 'fields.title': this.pageName };
    this.contentfulService.getPageContentResponse(query).then((resIncludes) => {
      this.mapBanner(resIncludes.includes.Entry);
      this.sharedDataService.addSharedData(this.iagPortalDisruptedBookingsPage.banner);
      this.mapPageInfo(resIncludes.items);
      this.mapSections(resIncludes.includes.Entry);
      this.mapNote(resIncludes.includes.Entry);
    });

    // console.log(this.iagPortalDisruptedBookingsPage);
  }

  private mapBanner(iagPortalDisruptedBookingsPageEntries: Entry<any>[]) {
    iagPortalDisruptedBookingsPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.iagPortalDisruptedBookingsPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.iagPortalDisruptedBookingsPage.banner.url = entry.fields?.url;
      this.iagPortalDisruptedBookingsPage.banner.editorEmail = editorDetails?.pop();
      this.iagPortalDisruptedBookingsPage.banner.editorShortName = editorDetails?.pop();
      this.iagPortalDisruptedBookingsPage.banner.editorFullName = editorDetails?.pop();
      this.iagPortalDisruptedBookingsPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapEntryToBanner(entry: Entry<any>) {

    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];

    this.iagPortalDisruptedBookingsPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url,
      video: videoDetails?.fields?.file?.url
    };
  }

  private mapSections(iagPortalDisruptedBookingsPageEntries: Entry<any>[]) {
    iagPortalDisruptedBookingsPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    this.iagPortalDisruptedBookingsPage.sections.sort((a, b) => a.order - b.order);

    this.iagPortalDisruptedBookingsPage.sectionsDisruptedBookingsIntro = this.iagPortalDisruptedBookingsPage.sections.filter((section) => GroupValidator.isDisruptedBookingsIntro(section.group));
    this.iagPortalDisruptedBookingsPage.sectionsDisruptedBookingsIntro.sort((a: { order: number }, b: { order: number }) => a.order - b.order);
    this.iagPortalDisruptedBookingsPage.sectionsDisruptedBookings = this.iagPortalDisruptedBookingsPage.sections.filter((section) => GroupValidator.isDisruptedBookings(section.group));
    this.iagPortalDisruptedBookingsPage.sectionsDisruptedBookings.sort((a: { order: number }, b: { order: number }) => a.order - b.order);
    this.iagPortalDisruptedBookingsPage.sectionsDisruptedBookingsChange = this.iagPortalDisruptedBookingsPage.sections.filter((section) => GroupValidator.isDisruptedBookingsChange(section.group));
    this.iagPortalDisruptedBookingsPage.sectionsDisruptedBookingsChange.sort((a: { order: number }, b: { order: number }) => a.order - b.order);
    this.iagPortalDisruptedBookingsPage.sectionsDisruptedBookingsCancel = this.iagPortalDisruptedBookingsPage.sections.filter((section) => GroupValidator.isDisruptedBookingsCancel(section.group));
    this.iagPortalDisruptedBookingsPage.sectionsDisruptedBookingsCancel.sort((a: { order: number }, b: { order: number }) => a.order - b.order);
    this.iagPortalDisruptedBookingsPage.sectionsDisruptedBookingsRebook = this.iagPortalDisruptedBookingsPage.sections.filter((section) => GroupValidator.isDisruptedBookingsRebook(section.group));
    this.iagPortalDisruptedBookingsPage.sectionsDisruptedBookingsRebook.sort((a: { order: number }, b: { order: number }) => a.order - b.order);
    this.iagPortalDisruptedBookingsPage.sectionsDisruptedBookingsRebooking = this.iagPortalDisruptedBookingsPage.sections.filter((section) =>
      GroupValidator.isDisruptedBookingsRebooking(section.group)
    );
    this.iagPortalDisruptedBookingsPage.sectionsDisruptedBookingsRebooking.sort((a: { order: number }, b: { order: number }) => a.order - b.order);
    this.iagPortalDisruptedBookingsPage.sectionsDisruptedBookingsRemove = this.iagPortalDisruptedBookingsPage.sections.filter((section) => GroupValidator.isDisruptedBookingsRemove(section.group));
    this.iagPortalDisruptedBookingsPage.sectionsDisruptedBookingsRemove.sort((a: { order: number }, b: { order: number }) => a.order - b.order);
    this.iagPortalDisruptedBookingsPage.sectionsDisruptedBookingsNotReceiving = this.iagPortalDisruptedBookingsPage.sections.filter((section) =>
      GroupValidator.isDisruptedBookingsNotReceiving(section.group)
    );

    this.iagPortalDisruptedBookingsPage.sectionsDisruptedBookingsNotReceiving.sort((a: { order: number }, b: { order: number }) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    let title:any = entry.fields['title'] as string;
    let pageTitle = title.split('#').pop();
    this.iagPortalDisruptedBookingsPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      subBody: entry.fields['subBody'] as string,
      titleColorClass: entry.fields['sectionClass'] as string
    });
    this.iagPortalDisruptedBookingsPage.sectionsDisruptionViewAccordion = this.iagPortalDisruptedBookingsPage.sections.filter((section) => section.group === 'disruption-view-accordion');
    this.iagPortalDisruptedBookingsPage.sectionsRefundConfirmationAccordion = this.iagPortalDisruptedBookingsPage.sections.filter((section) => section.group === 'refund-confirmation-accordion');
    this.iagPortalDisruptedBookingsPage.sectionsRebookAccordion = this.iagPortalDisruptedBookingsPage.sections.filter((section) => section.group === 'rebook-section-accordion');
    this.iagPortalDisruptedBookingsPage.sectionsRebookAccordion.sort((a: { order: number }, b: { order: number }) => a.order - b.order);
  }

  private mapNote(iagPortalDisruptedBookingsPageEntries: Entry<any>[]) {
    iagPortalDisruptedBookingsPageEntries
      .filter((entry) => ModelValidator.isNote(entry))
      .forEach((entry) => {
        this.mapEntryToNoteSection(entry);
        this.iagPortalDisruptedBookingsPage.noteSectionsPleaseBeAwareNote = this.iagPortalDisruptedBookingsPage.noteSections.filter((noteSections) =>
          GroupValidator.isPleaseBeAwareNote(noteSections.group)
        );
        this.iagPortalDisruptedBookingsPage.noteSectionsPleaseBeAwareNote.sort((a: { order: number }, b: { order: number }) => a.order - b.order);
        this.iagPortalDisruptedBookingsPage.noteSectionsDisruptedBookingsNote = this.iagPortalDisruptedBookingsPage.noteSections.filter((noteSections) =>
          GroupValidator.isDisruptedBookingsNote(noteSections.group)
        );
        this.iagPortalDisruptedBookingsPage.noteSectionsDisruptedBookingsNote.sort((a: { order: number }, b: { order: number }) => a.order - b.order);
        this.iagPortalDisruptedBookingsPage.noteSectionsRemoveFromQueueNote = this.iagPortalDisruptedBookingsPage.noteSections.filter((noteSections) =>
          GroupValidator.isRemoveFromQueueNote(noteSections.group)
        );
        this.iagPortalDisruptedBookingsPage.noteSectionsRemoveFromQueueNote.sort((a: { order: number }, b: { order: number }) => a.order - b.order);
      });
  }
  mapEntryToNoteSection(entry: Entry<any>) {

    
    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();

    this.iagPortalDisruptedBookingsPage.noteSections.push({
      fullTitle: entry.fields['title'] as string,
      title: pageTitle,
      iconClass: entry.fields['iconClass'] as string,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      noteClass: entry.fields['noteClass'] as string
    });
  }
}
